import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { FreelancerVerifiedBadgeComponent } from './freelancer-verified-badge.component';

@NgModule({
  declarations: [FreelancerVerifiedBadgeComponent],
  imports: [CommonModule, UiModule, ComponentsModule, TrackingModule],
  exports: [FreelancerVerifiedBadgeComponent],
})
export class FreelancerVerifiedBadgeModule {}
